export default {
  'app.settings.menuMap.basic': 'Configurações Básicas',
  'app.settings.menuMap.security': 'Configurações de Segurança',
  'app.settings.menuMap.binding': 'Vinculação de Conta',
  'app.settings.menuMap.notification': 'Notificações de Novas Mensagens',
  'app.settings.basic.avatar': 'Avatar',
  'app.settings.basic.change-avatar': 'Alterar avatar',
  'app.settings.basic.email': 'E-mail',
  'app.settings.basic.email-message': 'Por favor, informe seu e-mail!',
  'app.settings.basic.nickname': 'Apelido',
  'app.settings.basic.nickname-message': 'Por favor, informe seu apelido!',
  'app.settings.basic.profile': 'Perfil pessoal',
  'app.settings.basic.profile-message':
    'Por favor, informe seu perfil pessoal!',
  'app.settings.basic.profile-placeholder': 'Breve apresentação sobre você',
  'app.settings.basic.country': 'País/Região',
  'app.settings.basic.country-message': 'Por favor, informe seu país!',
  'app.settings.basic.geographic': 'Estado ou cidade',
  'app.settings.basic.geographic-message':
    'Por favor, informe sua localização!',
  'app.settings.basic.address': 'Endereço',
  'app.settings.basic.address-message': 'Por favor, informe seu endereço!',
  'app.settings.basic.phone': 'Número de telefone',
  'app.settings.basic.phone-message': 'Por favor, informe seu telefone!',
  'app.settings.basic.update': 'Atualizar informações',
  'app.settings.security.strong': 'Forte',
  'app.settings.security.medium': 'Média',
  'app.settings.security.weak': 'Fraca',
  'app.settings.security.password': 'Senha da Conta',
  'app.settings.security.password-description': 'Força atual da senha',
  'app.settings.security.phone': 'Telefone de Segurança',
  'app.settings.security.phone-description': 'Telefone vinculado',
  'app.settings.security.question': 'Pergunta de Segurança',
  'app.settings.security.question-description':
    'A pergunta de segurança não está configurada e a política de segurança pode proteger efetivamente a conta',
  'app.settings.security.email': 'E-mail de Recuperação',
  'app.settings.security.email-description': 'E-mail vinculado',
  'app.settings.security.mfa': 'Dispositivo MFA',
  'app.settings.security.mfa-description':
    'Nenhum dispositivo MFA vinculado. Após a vinculação, a autenticação em duas etapas poderá ser utilizada',
  'app.settings.security.modify': 'Modificar',
  'app.settings.security.set': 'Configurar',
  'app.settings.security.bind': 'Vincular',
  'app.settings.binding.taobao': 'Vincular Taobao',
  'app.settings.binding.taobao-description': 'Nenhuma conta Taobao vinculada',
  'app.settings.binding.alipay': 'Vincular Alipay',
  'app.settings.binding.alipay-description': 'Nenhuma conta Alipay vinculada',
  'app.settings.binding.dingding': 'Vincular DingTalk',
  'app.settings.binding.dingding-description':
    'Nenhuma conta DingTalk vinculada',
  'app.settings.binding.bind': 'Vincular',
  'app.settings.notification.password': 'Senha da Conta',
  'app.settings.notification.password-description':
    'Mensagens de outros usuários serão notificadas por mensagem interna',
  'app.settings.notification.messages': 'Mensagens do Sistema',
  'app.settings.notification.messages-description':
    'Mensagens do sistema serão notificadas por mensagem interna',
  'app.settings.notification.todo': 'Notificações de Tarefas',
  'app.settings.notification.todo-description':
    'As tarefas pendentes serão notificadas por mensagem interna',
  'app.settings.open': 'Ativar',
  'app.settings.close': 'Desativar',
};
